import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/print-fax.vue
var s = {
	name: "DtIconPrintFax",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--print-fax"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Print Fax",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2.5 1A.5.5 0 0 1 3 .5h6a.5.5 0 0 1 .5.5v3h.5a1.5 1.5 0 0 1 1.5 1.5V8A1.5 1.5 0 0 1 10 9.5h-.5V11a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V9.5H2A1.5 1.5 0 0 1 .5 8V5.5A1.5 1.5 0 0 1 2 4h.5V1ZM2 5a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 .5.5h.5V7a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1.5h.5a.5.5 0 0 0 .5-.5V5.5A.5.5 0 0 0 10 5H2Zm6.5-1h-5V1.5h5V4Zm0 3.5h-5v3h5v-3Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=print-fax.js.map